export function formatQmLabelPoNumber(value: string | null | undefined, maxVisible = 3): string {
  const raw = String(value || '').trim();
  if (!raw) return '';

  const poNumbers = raw
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);

  if (poNumbers.length <= maxVisible) return raw;

  return `${poNumbers.slice(0, maxVisible).join(', ')} +${poNumbers.length - maxVisible} more`;
}
